import createIcon from '../../createIcon';

/**
 * @component @name DinnerDining
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxOUgyMkwyMCAyMUg0TDIgMTlaTTUgNkg2VjdINVY2Wk01IDRINlY1SDVWNFpNOSA0VjVIN1Y0SDlaTTkgN0g3VjZIOVY3Wk02IDE1LjIzQzUuNjQgMTUuMzQgNS4zMSAxNS41MSA1IDE1LjdWOEg2VjE1LjIzWk00IDE2LjUyQzMuNjIgMTYuOTYgMy4zMiAxNy40NSAzLjE2IDE4SDE5Ljk4QzE5Ljk5IDE3Ljg0IDIwLjAxIDE3LjY3IDIwLjAxIDE3LjVDMjAuMDEgMTQuNDYgMTcuNTUgMTIgMTQuNTEgMTJDMTIuMjIgMTIgMTAuMjYgMTMuNCA5LjQzIDE1LjRDOC44NCAxNS4xNSA4LjE5IDE1IDcuNSAxNUM3LjMzIDE1IDcuMTcgMTUuMDIgNyAxNS4wNFY4SDlDMTAuMDMgOC4wNiAxMC45IDcuMDQgMTEgNkgyMVY1SDExQzEwLjkgMy45NSAxMC4wMyAzLjAzIDkgM0gzVjRINFY1SDNWNkg0VjdIM1Y4SDRWMTYuNTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DinnerDining = createIcon('DinnerDining', [
  [
    'path',
    {
      d: 'M2 19H22L20 21H4L2 19ZM5 6H6V7H5V6ZM5 4H6V5H5V4ZM9 4V5H7V4H9ZM9 7H7V6H9V7ZM6 15.23C5.64 15.34 5.31 15.51 5 15.7V8H6V15.23ZM4 16.52C3.62 16.96 3.32 17.45 3.16 18H19.98C19.99 17.84 20.01 17.67 20.01 17.5C20.01 14.46 17.55 12 14.51 12C12.22 12 10.26 13.4 9.43 15.4C8.84 15.15 8.19 15 7.5 15C7.33 15 7.17 15.02 7 15.04V8H9C10.03 8.06 10.9 7.04 11 6H21V5H11C10.9 3.95 10.03 3.03 9 3H3V4H4V5H3V6H4V7H3V8H4V16.52Z',
      key: 'j4mquo',
    },
  ],
]);

export default DinnerDining;
